import React from "react";
import { Link } from "react-router-dom";
import useBranding, { mailto } from "../utils/branding";
import { SHOW_DEVELOPER_API } from "../features";

// One compact line so pages keep their vertical space.
const Footer = () => {
  const branding = useBranding();
  const links = [
    { label: "Impressum", href: branding.imprintUrl },
    { label: "Terms", href: branding.termsUrl },
    { label: "Privacy", href: branding.privacyUrl },
    { label: "Contact", href: mailto(branding.supportEmail, branding.productName), external: false },
  ];
  return (
    <footer className="bf-footer footerFix">
      <span className="bf-footer__copy">
        © {new Date().getFullYear()} {branding.companyName}
      </span>
      <nav className="bf-footer__links" aria-label="Legal and help">
        {links.map((l) => (
          <a key={l.label} href={l.href} {...(l.external === false ? {} : { target: "_blank", rel: "noopener noreferrer" })}>
            {l.label}
          </a>
        ))}
        {SHOW_DEVELOPER_API && <Link to="/developers">Developers</Link>}
        <Link to="/release-notes">What's new</Link>
      </nav>
    </footer>
  );
};

export default Footer;
